// Mocked Payroll Settings Data

import { PayrollSettingsQueryModel } from "./types";

export const mockedPayrollSettings: PayrollSettingsQueryModel = {
  // --- Payroll Module ---
  subtractPPK: "inCurrentMonth",
  includeBonusAToPremium: true,
  decemberSalaryBasedOnJanuaryParams: false,
  includeLeavesAndSickInRecords: true,
  calculateLeaveAndSickAmounts: true,
  accidentContributionRate: 1.67,

  sickLeaveMode: "grossZus",

  // --- Calculation Parameters – Absences ---
  variableComponentsFromHours: "real",
  variableLeaveComponentsCalc: "automatic",
  leaveSalaryPaymentTiming: "endOfMonth",
  sickSalaryPaymentTiming: "nextMonth",

  // --- Absence Calculation Components ---
  absenceComponents: [
    { code: "BASE", includeInLeave: true, isFixedComponent: true, includeInSick: true },
    { code: "ALLOWANCE_ALL", includeInLeave: true, isFixedComponent: false, includeInSick: true },
    { code: "ALLOWANCE_DUTY", includeInLeave: true, isFixedComponent: false, includeInSick: true },
    { code: "ALLOWANCE_OVERTIME", includeInLeave: true, isFixedComponent: false, includeInSick: true },
    { code: "ALLOWANCE_NIGHT", includeInLeave: true, isFixedComponent: false, includeInSick: true },
    { code: "ALLOWANCE_EU", includeInLeave: true, isFixedComponent: false, includeInSick: true },
    { code: "SETTLEMENT_ALL", includeInLeave: true, isFixedComponent: false, includeInSick: false },
    { code: "SETTLEMENT_DUTY", includeInLeave: true, isFixedComponent: false, includeInSick: true },
    { code: "SETTLEMENT_NIGHT", includeInLeave: true, isFixedComponent: false, includeInSick: true },
    { code: "SETTLEMENT_OVERTIME", includeInLeave: true, isFixedComponent: false, includeInSick: true },
    { code: "DUTY", includeInLeave: false, isFixedComponent: false, includeInSick: false },
    { code: "NIGHT_WORK", includeInLeave: false, isFixedComponent: false, includeInSick: false },
    { code: "OVERTIME", includeInLeave: true, isFixedComponent: false, includeInSick: true },
    { code: "SETTLEMENT_EU", includeInLeave: true, isFixedComponent: false, includeInSick: true },
    { code: "BONUS", includeInLeave: true, isFixedComponent: false, includeInSick: true },
    { code: "BONUS_A", includeInLeave: false, isFixedComponent: false, includeInSick: false },
    { code: "BONUS_B", includeInLeave: false, isFixedComponent: false, includeInSick: false },
    { code: "BONUS_C", includeInLeave: false, isFixedComponent: false, includeInSick: false },
    { code: "BONUS_D", includeInLeave: false, isFixedComponent: false, includeInSick: false },
    { code: "COST_C", includeInLeave: false, isFixedComponent: false, includeInSick: true },
    { code: "COST_D", includeInLeave: false, isFixedComponent: false, includeInSick: true },
    { code: "VACATION_PAY", includeInLeave: false, isFixedComponent: false, includeInSick: true },
    { code: "MINIMUM_WAGE_ADJUSTMENT", includeInLeave: true, isFixedComponent: false, includeInSick: true },
  ],
};
